<template>
  <div>载入中</div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    rediret() {
      let type = sessionStorage.getItem("userType");
      if (type == "zfyh" || type == "gly") {
        this.$axios.get(`/business/mapSite/mapConfig`).then((res) => {
          console.log(res.data.data);
          if (res.data.data == true) {
            this.$router.replace("/home");
          } else {
            this.$router.replace("/regionCheck");
          }
        });
      } else {
        this.$router.replace("/index");
      }
    },
  },
  mounted() {
    this.rediret();
  },
};
</script>

<style lang="less" scoped>
</style>